import { Component, OnInit } from '@angular/core';
import { AuthorizeService } from 'src/app/services/authorize/authorize.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { WorkOrderService } from 'src/app/services/workOrder/workOrder.service';


interface MatchManufacturingResponse {
  unmatchedRows: string[];
  unmatchedCount: number;
  matchedCount: number;
  rowCount: number;
  duplicateCount: number;
}

@Component({
  selector: 'app-manufacturing-dashboard',
  templateUrl: './manufacturing-dashboard.component.html',
  styleUrls: ['./manufacturing-dashboard.component.scss'],
})
export class ManufacturingDashboardComponent implements OnInit {
isLoading: boolean = false;
  isOneTankAdmin = false;
  isDistributorAdmin = false;
  distId?: number;
  workOrderId?: number;
  workOrderForm!: FormGroup;
  submitted: boolean = false;
  cta: string = "Add Work Order";
  disableRemove: boolean = false;
  gridClass = 'ag-theme-alpine-dark';
  rowData: any[]= [];
  isViewOnly = false;
  anyItemSelected: boolean = false;
  selectedDistId?: number;
  selectedDistName?: string;
  selectedFile: File | null = null;
  unmatchedRows: string[]=[];
  unmatchedCount: number = 0;
  matchedCount: number = 0;
  rowCount: number = 0;
  duplicateCount: number = 0;
  failedRegs: any[]=[];
  resultText1?: string;
  resultText2?: string
  errorResultText1?: string;
  errorResultText2?: string;
  userId?: number;

  

  constructor(
    private _workOrderService: WorkOrderService,
    private toastService: ToastrService,
    private _route: ActivatedRoute) {
  }

  ngOnInit() {
    
  }

    compareFunction(item: { id: any; }, selected: { id: any; }) {
        return item.id === selected.id
    }


    submit() {
        this.errorResultText1 = '';
        this.resultText1 = '';

        if (!this.selectedFile) {
            this.toastService.error('No file selected.');
            return;
        } else {
            this.isLoading = true;
            const formData = new FormData();
            formData.append('file', this.selectedFile);

            this._workOrderService.matchManufacturingFile(formData)
                .subscribe((response: string | MatchManufacturingResponse) => {

                    if (typeof response === 'string') {
                        // This is the error case
                        this.toastService.error(response);
                        this.isLoading = false;
                        return;
                    }

                    this.unmatchedRows = response.unmatchedRows;
                    this.unmatchedCount = response.unmatchedCount;
                    this.matchedCount = response.matchedCount;
                    this.rowCount = response.rowCount;
                    this.duplicateCount = response.duplicateCount;

                    if (this.unmatchedRows.length < 1) {
                        this.errorResultText1 = '';
                        this.resultText1 = "All Serial Numbers successfully confirmed.";
                    } else {
                        this.errorResultText1 = "The following Serial Number(s) could not be confirmed:";
                    }

                    this.isLoading = false;
                });
        }
    }


    onFileSelected(event: Event, fileInput: HTMLInputElement): void {
        const input = event.target as HTMLInputElement;

        if (input.files && input.files.length > 0) {
            const file = input.files[0];
            const fileName = file.name;
            const fileType = file.type;

            const isCSV = fileName.endsWith('.csv') &&
                (fileType === 'text/csv' || fileType === 'application/vnd.ms-excel');

            if (!isCSV) {
                this.toastService.error('Please select a valid .csv file.');
                this.selectedFile = null;
                fileInput.value = ''; // ✅ Clear the file input
                return;
            }

            this.selectedFile = file;
        }
    }


    downloadLogs() {
        this._workOrderService.downloadLogs$().subscribe(blob => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');

            a.href = url;
            a.download = 'MatchLogs.csv';
            a.click();

            window.URL.revokeObjectURL(url);
        });
    }



}


